import React from 'react'
import onClickOutside from "react-onclickoutside";
import PropTypes from "prop-types";

const OutsideClick = ({ handler, children }) => {
    return <div>{children}</div>;
};

OutsideClick.propTypes = {
    handler: PropTypes.func,
    children: PropTypes.node.isRequired,
};

export const ClickOutside = onClickOutside(OutsideClick);
  


// WEBPACK FOOTER //
// ./components/common/ClickOutsideWrapper.js